module.exports = __webpack_public_path__ + "img/integration.021cf095.svg";